import { Fragment } from "react";
import PropTypes from "prop-types";

import { cn } from "@helpers/general";

import ALShopifyImage from "@components/al_components/ALShopifyImage";
import USPFakeImage from "@components/gallery/USPFakeImage";
import { ComponentType } from "@constants/ComponentType";

const INDEX_USPS = 3;

function ThumbnailSidebar({
  images,
  activeIdx,
  onThumbClick,
  productTags,
  componentType,
  topPosition,
  showUSPImage,
}) {
  const getDisplayIdx = (rawIdx) => (showUSPImage && rawIdx >= INDEX_USPS ? rawIdx + 1 : rawIdx);

  return (
    <div
      data-comp="quick-view-desktop"
      className={cn(
        "flex flex-col gap-[5px] mr-[25px] mobile:hidden",
        componentType === ComponentType.PDP_ADS && "mt-[25px]"
      )}
      style={topPosition}
    >
      {images.map((image, idx) => (
        <Fragment key={image?.url || idx}>
          {showUSPImage && idx === INDEX_USPS && (
            <button
              type="button"
              className={cn(
                "overflow-hidden outline-none min-w-[55px]",
                "border transition-colors",
                activeIdx === INDEX_USPS
                  ? "border-black"
                  : "border-transparent hover:border-neutral-300"
              )}
              onClick={() => onThumbClick(INDEX_USPS)}
            >
              <USPFakeImage
                idx={idx}
                tags={productTags}
                aspectRatio="aspect-square"
                titleTextSize="text-[0.11vw]"
                uspTextSize="text-[0.15vw]"
                componentType={componentType}
              />
            </button>
          )}
          <button
            type="button"
            className={cn(
              "overflow-hidden outline-none min-w-[55px]",
              "border transition-colors",
              getDisplayIdx(idx) === activeIdx
                ? "border-black"
                : "border-transparent hover:border-neutral-300"
            )}
            onClick={() => onThumbClick(getDisplayIdx(idx))}
            data-testid={`thumbnail-image-${idx}`}
          >
            <ALShopifyImage width={55} height={60} url={image?.url} alt={image.altText} />
          </button>
        </Fragment>
      ))}
    </div>
  );
}

ThumbnailSidebar.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string, altText: PropTypes.string }))
    .isRequired,
  activeIdx: PropTypes.number.isRequired,
  onThumbClick: PropTypes.func.isRequired,
  topPosition: PropTypes.shape({ position: PropTypes.string, top: PropTypes.string }),
  productTags: PropTypes.arrayOf(PropTypes.string),
  componentType: PropTypes.string.isRequired,
  showUSPImage: PropTypes.bool,
};

export default ThumbnailSidebar;
